"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var sizePorcent = function sizePorcent(size, porcent) {
  return Math.round(size * porcent / 100);
};

var retrieveStyle = function retrieveStyle(theme) {
  var heightCard = (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'containerCard', 'height'], 135);
  var widthCard = (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'containerCard', 'width'], 300);
  var tickColor = (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'tick', 'backgroundColor'], _colors["default"].blue);
  var tabletMobile = (0, _seamlessImmutable.getIn)(theme, ['Media', 'tabletMobile']);
  return {
    containerCard: _defineProperty({
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'containerCard', 'backgroundColor'], _colors["default"].blue),
      height: heightCard,
      width: widthCard,
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'containerCard', 'hover', 'backgroundColor'], _colors["default"].darkBlue)
      }
    }, tabletMobile, {
      height: (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'containerCard', 'height'], 135),
      width: (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'containerCard', 'width'], 300),
      alignItems: 'center',
      flexDirection: 'column'
    }),
    isSelected: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'isSelected', 'backgroundColor'], _colors["default"].blue),
      ':hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'isSelected', 'hover', 'backgroundColor'], _colors["default"].darkBlue)
      }
    },
    containerText: _defineProperty({
      height: sizePorcent(96, heightCard)
    }, tabletMobile, {
      height: sizePorcent(66, heightCard),
      width: '100%'
    }),
    image: {
      height: sizePorcent(27, widthCard),
      width: sizePorcent(27, widthCard)
    },
    description: {
      color: "".concat((0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'description', 'color'], _colors["default"].white), " !important"),
      fontSize: "".concat((0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'description', 'fontSize']), "px !important"),
      fontWeight: "".concat((0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'description', 'fontWeight']), " !important")
    },
    name: {
      color: "".concat((0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'name', 'color'], _colors["default"].white), " !important"),
      fontSize: "".concat((0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'name', 'fontSize']), "px !important"),
      fontWeight: "".concat((0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'name', 'fontWeight']), " !important")
    },
    selectedText: {
      color: "".concat((0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'selectedText', 'color']))
    },
    tick: {
      backgroundColor: _colors["default"].white,
      fill: tickColor,
      border: "2px solid ".concat(tickColor),
      borderRadius: '50%',
      padding: 3,
      height: sizePorcent(heightCard, 8),
      width: sizePorcent(heightCard, 8)
    },
    icon: {
      position: 'absolute',
      right: (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'icon', 'right'], 20),
      top: (0, _seamlessImmutable.getIn)(theme, ['UTImageRadio', 'top', 'right'], -10)
    }
  };
};

exports.retrieveStyle = retrieveStyle;